import PolicyManagement from './PolicyManagement'

export default PolicyManagement
